import { render, staticRenderFns } from "./Organizations.vue?vue&type=template&id=3f7d31bf&"
import script from "./Organizations.vue?vue&type=script&lang=js&"
export * from "./Organizations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports